import React, { Component } from 'react';
import { ToastContainer } from 'react-toastify';
import { Switch, Route, Redirect } from 'react-router-dom';
import IAM from './iam';
import EVS from './evs';
import LMS from './lms/lms';
import NoPath from './nopath';
import Reports from './reports';
import Settings from './settings';
import Guide from './guide/guide';
import Campaigns from './campaigns';
import Header from './header/header';
import Department from './department';
import LandingURL from './landing-url';
import Actions from './actions/actions';
import Billing from './billing/billing';
import SideBar from './sidebar/side-bar';
import Calendar from './calender/calender';
import Templates from './campaign-template';
import Dashboard from './dashboard/dashboard';
import Logs from './iam/audit-logs/audit-logs';
import HackRecord from './hackrecord/hack-record';
import Integration from './integrations/integrations';
import Schedule from '../component/schedule/schedule';
import Ad from './integrations/ad';
import Sso from './integrations/sso';
import Azure from './integrations/azure';
import Gsuite from './integrations/g-suite';
import CustomDasdboard from './custom-dashboard/custom-dashboard';
import './index.css';
import axios from '../axios';
import apiError from '../error';
import swalAlert from '../swalFunction';
import { featuresObj } from '../globalData';
import { getCookie, appType } from '../function';
import MCP from './mcp/mcp';
import AiSidebar from './sidebar/ai-sidebar';

export default class App extends Component {
	constructor(props){
		super(props);
		this.state = {
			show: true,
			appType: appType(),
			userAgent: getCookie('userAgent'),
			userType: getCookie('userType'),
			isDashboard: localStorage.getItem('isDashboard') || false,
			isPackageFetched: false,
			chatSessions: [],
			currentSessionId: null,
		}
		this.isTAconnected = getCookie('isTAconnected');
		this.startNewChatFn = null;
		this.openHistoryFn = null;
		this.sidebarBridge = null;
		this.handleNewChat    = () => this.startNewChatFn && this.startNewChatFn();
		this.handleOpenSession = (id) => this.sidebarBridge && this.sidebarBridge.openSession(id);
		this.handleLoadSessions = () => this.sidebarBridge && this.sidebarBridge.loadSessions();
		this.handleCleanTitle   = (t) => this.sidebarBridge ? this.sidebarBridge.cleanTitle(t) : (t || "New Conversation");
	}

	loadAllFeatures = async() => {
		try{
			let res = await axios.get('/api/package/get-all-features');
			for(let feature of res.data.features){
				featuresObj[feature] = true;
			}
			this.setState({isPackageFetched: true})
		}catch(error){
			this.setState({isPackageFetched: true})
			apiError(error);
		}
	}

	async componentDidMount() {
		this.loadAllFeatures();
		if(this.isTAconnected) this.syncVerifiedDomainsWithTA();

		var loadScript = function (script) {
			var tag = document.createElement('script');
			tag.async = false;
			var scriptText = document.createTextNode(script)
			tag.appendChild(scriptText);
			var body = document.getElementsByTagName('body')[0];
			body.appendChild(tag);
		}
		// if(navigator.onLine && this.state.appType === "SaaS"){
			loadScript(`window.ZohoHCAsap=window.ZohoHCAsap||function(a,b){ZohoHCAsap[a]=b;};(function(){var d=document;var s=d.createElement("script");s.type="text/javascript";s.defer=true;s.src="https://desk.zoho.com/portal/api/web/inapp/219327000005213009?orgId=653592556";d.getElementsByTagName("head")[0].appendChild(s);})();`);
			loadScript(`window.ZohoHCAsapSettings = { ticketsSettings: { preFillFields: { "email": { defaultValue: localStorage['email'] }, "contactId": { defaultValue: localStorage['firstname'] + ' ' + localStorage['lastname'] } } }, }`);
			loadScript(`window._mfq = window._mfq || []; (function() { var mf = document.createElement("script"); mf.type = "text/javascript"; mf.defer = true; mf.src = "//cdn.mouseflow.com/projects/975fb8f2-fe4b-4e37-83f4-5883edfd61f5.js"; document.getElementsByTagName("head")[0].appendChild(mf); })();`);
			loadScript(`(function(c,l,a,r,i,t,y){
				c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
				t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
				y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
			})(window, document, "clarity", "script", "mkhnrsm3zj");`);
			loadScript(`setTimeout(function(){
				if (window.clarity) {
					clarity("set", "user_email", localStorage['email'] || "unknown");
					clarity("set", "user_name", (localStorage['firstname'] || "") + " " + (localStorage['lastname'] || ""));
				}
			}, 1000);`);
			
		// }

		var loadLanguageScript = function (src) {
			var tag = document.createElement('script');
			tag.async = false;
			tag.src = src;
			var body = document.getElementsByTagName('body')[0];
			body.appendChild(tag);
		}
		if(navigator.onLine){
			loadLanguageScript(`https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit2`);
			loadScript(`function googleTranslateElementInit2() {new google.translate.TranslateElement({pageLanguage: 'en',autoDisplay: false}, 'google_translate_element2');}`);
		}
	}

	nextPath = path => this.props.history.push(path);

	sidebarShow = () => {
		this.setState({show: !this.state.show});
	}

	collapseSidebar = () => {
		if (this.state.show) this.setState({ show: false });
	}

	handleLMS = async() => {
        document.body.style.cursor = "wait";
        axios.get('/api/lms', {})
        .then(res => {
            document.body.style.cursor = "";
			const allowedBaseURL = process.env.REACT_APP_LMS_URL;
			const allowedDomain = new URL(allowedBaseURL).hostname;
			const url = new URL(res.data.url);
			
			const allowedDomainParts = allowedDomain.split('.').slice(-2).join('.');
			const urlDomainParts = url.hostname.split('.').slice(-2).join('.');
			
			// Validate domain
			if (urlDomainParts !== allowedDomainParts) {
				swalAlert("Security Alert", "Invalid redirect URL detected!", "error");
				return;
			}
			
			// Prevent Open Redirection
			const redirectUrl = url.searchParams.get("url"); // Potential redirection target
			if (redirectUrl) {
				try {
					const parsedRedirectUrl = new URL(redirectUrl, allowedBaseURL); // Resolve relative paths
					const redirectDomainParts = parsedRedirectUrl.hostname.split('.').slice(-2).join('.');
			
					if (redirectDomainParts !== allowedDomainParts) {
						swalAlert("Security Alert", "Invalid redirect target detected!", "error");
						return;
					}
				} catch (error) {
					console.log("Invalid redirect URL detected:", error);
					swalAlert("Security Alert", "Invalid redirect target detected!", "error");
					return;
				}
			}	
			window.open(res.data.url, '_blank');
        })
        .catch(err => {
            apiError(err);
            document.body.style.cursor = "";
        });
	}
	
	handleCourseAnalytics = () => {
		document.body.style.cursor = "wait";
        axios.get('/api/lms', {
			params: {
                url: `/analytic/list`
            }
		})
        .then(res => {
            document.body.style.cursor = "";
			const allowedBaseURL = process.env.REACT_APP_LMS_URL;
			const allowedDomain = new URL(allowedBaseURL).hostname;
			const url = new URL(res.data.url);
			
			const allowedDomainParts = allowedDomain.split('.').slice(-2).join('.');
			const urlDomainParts = url.hostname.split('.').slice(-2).join('.');
			
			// Validate domain
			if (urlDomainParts !== allowedDomainParts) {
				swalAlert("Security Alert", "Invalid redirect URL detected!", "error");
				return;
			}
			
			// Prevent Open Redirection
			const redirectUrl = url.searchParams.get("url"); // Potential redirection target
			if (redirectUrl) {
				try {
					const parsedRedirectUrl = new URL(redirectUrl, allowedBaseURL); // Resolve relative paths
					const redirectDomainParts = parsedRedirectUrl.hostname.split('.').slice(-2).join('.');
			
					if (redirectDomainParts !== allowedDomainParts) {
						swalAlert("Security Alert", "Invalid redirect target detected!", "error");
						return;
					}
				} catch (error) {
					console.log("Invalid redirect URL detected:", error);
					swalAlert("Security Alert", "Invalid redirect target detected!", "error");
					return;
				}
			}
            window.open(res.data.url, '_blank')
        })
        .catch(err => {
			document.body.style.cursor = "";
			if(err.response?.data?.errors[0]==="TLMS_CONNECTED_TO_THREATCOP_ADMIN"){
				swalAlert("TLMS connected to Threatcop Admin", "This function has been terminated. Please connect TSAT with Threatcop Admin and manage TSAT/TLMS accordingly.", "error");
				return;
			}
            apiError(err);
        });
	}

	syncVerifiedDomainsWithTA = async() => {
		try{
			await axios.post('/api/adminCentral/sync-TA-verified-domains');
		}catch(error){
			console.log("Error occured while syncing verified domains from threatcop admin: ", error);
		}
	}

	useQuery = () => {
        return new URLSearchParams(window.location.search);
    }

	render() {	
		let activeClass = 'dashboard', activeSubClass = '', isDashboard = getCookie('isDashboard');
		if(this.props.location && this.props.location.pathname && this.props.location.pathname.length > 1){
			activeClass = (this.props.location.pathname).split('/')[1];
			activeSubClass = this.props.location.pathname && (this.props.location.pathname).split('/')[2] ? (this.props.location.pathname).split('/')[2]: this.useQuery().get('tab')? this.useQuery().get('tab'): null;
		}
		const isAwarenessManager = activeClass === 'awareness-manager';
		return (
			<div className="containerbar">
				{isAwarenessManager
					? <AiSidebar
						show={this.state.show}
						sideBarFun={this.sidebarShow}
						nextPath={this.nextPath}
						onNewChat={this.handleNewChat}
						chatSessions={this.state.chatSessions}
						currentSessionId={this.state.currentSessionId}
						onOpenSession={this.handleOpenSession}
						onLoadSessions={this.handleLoadSessions}
						cleanTitle={this.handleCleanTitle}
					/>
					: <SideBar activeClass={activeClass} show={this.state.show} activeSubClass={activeSubClass} sidebar={this.state.show} sideBarFun={this.sidebarShow} nextPath={ this.nextPath } handleLMS={ this.handleLMS } handleCourseAnalytics={this.handleCourseAnalytics} isPackageFetched={this.state.isPackageFetched} />
				}
				<div className={`${this.state['show'] ? "main-content" : "main-content expand"}${isAwarenessManager ? " ai-main-content" : ""}`}>
					{!isAwarenessManager && <Header nextPath={ this.nextPath }/>}
					<Switch>
						<Route 
							path={['/', '/dashboard', '/home']} 
							exact 
							render={(props) => 
								(isDashboard || this.state.isDashboard || true) 
									? <Dashboard {...props} isPackageFetched={this.state.isPackageFetched} /> 
									: <Guide {...props} />
							} 
						/>
						<Route path='/campaign' component={ Campaigns }/>
						<Route path='/evs' component={ EVS }/>
						<Route path='/iam' component={ this.state.userType === 'root' ? IAM: NoPath }/>
						<Route path='/lms' component={ LMS }/>
						<Route path='/reports' component={ Reports }/>
						<Route path='/schedule' component={ Schedule }/>
						<Route path='/actions' component={ Actions }/>
						<Route path='/audit-logs' component={ Logs }/>
						<Route path='/settings' component={ Settings }/>
						<Route path='/department' component={ Department }/>
						<Route path='/hackrecord' component={ HackRecord }/>
						<Route 
							path="/templates" 
							render={(props) => (
								<Templates {...props} isPackageFetched={this.state.isPackageFetched} />
							)}
							/>
						<Route path='/guide' exact component = { Guide } />
						<Route path='/calendar' exact component = { Calendar } />
						<Route path='/billing' exact component = { Billing } />
						<Route path='/integration' exact component = { Integration } />
						<Route path='/ad' exact component = { Ad } />
						<Route path='/azure' exact component = { Azure } />
						<Route path='/g-suite' exact component = { Gsuite } />
						<Route path='/sso' exact component = { Sso } />
						<Route path='/landing-url' component = { LandingURL } />
						<Route path='/custom-dashboard' component = { CustomDasdboard } />
						{/* <Route
							path='/chat'
							render={(props) => <Redirect to={MCP.getDefaultRoute(props.location.search)} />}
						/> */}
						<Route path='/awareness-manager' render={(props) => <MCP {...props}
							onRegisterNewChat={(fn) => { this.startNewChatFn = fn; }}
							onRegisterOpenHistory={(fn) => { this.openHistoryFn = fn; }}
							onCollapseSidebar={this.collapseSidebar}
							onRegisterSidebarBridge={(bridge) => {
								this.sidebarBridge = bridge;
								this.setState({ chatSessions: bridge.sessions, currentSessionId: bridge.currentSessionId });
							}}
						/>}/>
						<Route render={() => (<Redirect to="/invalid" />)}/>
					</Switch>
					<ToastContainer position="top-right" autoClose={5000} />
				</div>
			</div>
		);
	}
}
